module.exports = __webpack_public_path__ + "static/media/Loader.11c6f83d.svg";